import { client } from "./client";

export const partSignService = {
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  getPartSigns(params: any) {
    return client.get("/shop/part-signs", { params }).then((res) => res.data);
  },
};
